import { defineMessages } from 'react-intl'

export default defineMessages({
  addAdministrator: {
    id: 'OrganizationSpaces.UserSearch.Label',
    defaultMessage: 'Add an Administrator'
  },
  addingRole: {
    id: 'OrganizationSpaces.AddingSpaceAdminRole',
    defaultMessage: 'Adding space administrator role to user'
  },
  confirmRemove: {
    id: 'OrganizationSpaces.ConfirmRemove',
    defaultMessage: 'Really want to remove?'
  },
  confirmSpaceAdminRemove: {
    id: 'OrganizationSpaces.ConfirmRemoveSubMessage',
    defaultMessage: 'This user be will be removed from the space admin role'
  },
  email: {
    id: 'Email',
    defaultMessage: 'Email'
  },
  name: {
    id: 'Name',
    defaultMessage: 'Name'
  },
  noAdmins: {
    id: 'OrganizationSpaces.NoSpaceAdmins',
    defaultMessage: 'Currently there are no administrators for this space'
  },
  removingRole: {
    id: 'OrganizationSpaces.RemovingSpaceAdminRole',
    defaultMessage: 'Removing space administrator role from user'
  },
  searchPlaceholder: {
    id: 'OrganizationSpaces.UserSearch.Placeholder',
    defaultMessage: 'Employee Name'
  },
  spaceAdministrators: {
    id: 'OrganizationSpaces.SpaceAdministrators',
    defaultMessage: 'Space Administrators'
  },
  users: {
    id: 'users',
    defaultMessage: 'users'
  }
})
